import * as breakpoints from "../styles/breakpoints";

export function isMobile() {
	return window.innerWidth <= breakpoints.ipadPortrait - 1;
}

export function isTablet() {
	return (
		window.innerWidth >= breakpoints.ipadPortrait &&
		window.innerWidth <= breakpoints.ipadLandscape
	);
}

export function isPortraitTablet() {
	return (
		window.innerWidth <= breakpoints.maxMobile &&
		window.innerWidth >= breakpoints.minPortraitTablet
	);
}

export function isDesktop() {
	return window.innerWidth >= breakpoints.ipadLandscape + 1;
}
